export const EshopUrl = "https://www.odkarla.cz/";
export const SkladUrl = "https://sklad.odkarla.cz/";
export const RexUrl = "https://rex.odkarla.cz/";
export const MaxUrl = "https://max.odkarla.cz/";
